import { AcceptItemPriceChangeState } from './acceptItemPriceChange.types'

const initialState: AcceptItemPriceChangeState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
